import React from "react";
import {useLoaderData} from "react-router-dom";
import {useBreakpoint,} from "@chakra-ui/react";
import client from "../../../../helpers/Client";
import request2APIParams from "../../../../helpers/request2APIParams";
import CustomerListCardView from "./CustomerListCardView";
import CustomerListTableView from "./CustomerListTableView";

export async function CustomerLoader({request}) {
  const params = request2APIParams(request)
  const customers = (await client.get("/customers/", { params })).data;
  return customers
}

export default function Customer() {
  const bp = useBreakpoint({ssr: false});
  const customers = useLoaderData();
  const Component = {
    'base': CustomerListCardView,
    'sm': CustomerListTableView,
    'md': CustomerListTableView,
    'lg': CustomerListTableView,
  }[bp] || CustomerListTableView
  return <Component customers={customers}/>
}
